import {
  TDiscountTypes,
  TGetExportConfigFn,
} from '../../../../utils/types';
import { CustomDialog } from '../../../../components/CustomDialog';
import { useState } from 'react';
import { Button } from '../../../../components';
import { useExportDiscountMutation } from '../../../../services/discounts';
import { downLoadLink } from '../../../../utils/functions/common';
import { useAppDispatch } from '../../../../storeHook';
import { showAlert } from '../../../../services/alert';
import * as yup from 'yup';
import { useGetAllPlantsQuery } from '../../../../services/common';
import { useFormWithSchema } from '../../../../utils/functions/yupFormTypescript';
import MultiSelect from '../../../../components/formControllers/multiSelect';

const getExportConfig: TGetExportConfigFn = (
  discountType
) => {
  switch (discountType) {
    case 'sku':
      return {
        title: 'SKU Discount Export',
        exportType: 'SKU_DISCOUNT',
      };
    default:
      return {
        title: 'Bulk Discount Export',
        exportType: 'BULK_DISCOUNT',
      };
  }
};

const formSchema = yup.object({
  plants: yup.array(yup.string().required()).required(),
});
type TFormData = yup.InferType<typeof formSchema>;

export const DiscountExport: React.FC<{
  type: TDiscountTypes;
}> = ({ type }) => {
  const dispatch = useAppDispatch();
  const { title, exportType } = getExportConfig(type);
  const [exportDiscount] = useExportDiscountMutation();
  const [open, setOpen] = useState(false);

  const { data: plantList } = useGetAllPlantsQuery();
  const formattedPlantList = plantList?.map((ele) => ({
    key: `${ele.plantName} [${ele.plantCode}]`,
    value: ele.plantCode,
    label: `${ele.plantName} [${ele.plantCode}]`,
  }));

  const {
    formState: { errors },
    handleSubmit,
    control,
  } = useFormWithSchema(formSchema, {
    mode: 'onTouched',
  });

  const onExportClick = ({ plants }: TFormData) => {
    if (plants.length === 0) {
      dispatch(
        showAlert({
          content: 'Please select at least one plant',
          severity: 'error',
        })
      );
      return;
    }
    setOpen(false);
    exportDiscount({
      data: {
        plants: plants.join(','),
      },
      exportType,
    })
      .unwrap()
      .then((res) => {
        downLoadLink(res.data || res.url);
        if (res.success) {
          dispatch(
            showAlert({
              content: 'discounts Exported successfully',
            })
          );
        } else {
          dispatch(
            showAlert({
              content: 'No data found',
              severity: 'error',
            })
          );
        }
      })
      .catch((err) => {
        console.log('error', err);
        // this.utility.handleError(err);
      });
  };

  return (
    <>
      <Button
        onClick={() => setOpen(!open)}
        className="ml-3"
        variant="button--secondary">
        Export
      </Button>
      <CustomDialog
        dialogTitle={title}
        open={open}
        setOpen={setOpen}
        onSubmit={handleSubmit((data) =>
          onExportClick(data)
        )}
        isForm
        actionText={{ submit: 'Export', cancel: 'Cancel' }}
        maxWidth="sm">
        <form
          onSubmit={handleSubmit((data) =>
            onExportClick(data)
          )}>
          <MultiSelect
            label="Plants"
            name="plants"
            control={control}
            options={formattedPlantList}
            error={errors.plants?.message}
            required
          />
        </form>
      </CustomDialog>
    </>
  );
};
